import { Elements } from '@stripe/react-stripe-js';

import { CardFieldsContainer } from 'payments/components/CardFieldsContainer';
import { STRIPE_CIRCULAR_FONT } from 'payments/constants/fonts';
import { useStripePayments } from 'payments/hooks/usePayments';
import { useStripe } from 'payments/hooks/useStripe';
import { StripePaymentFormProvider } from 'payments/providers/StripePaymentFormProvider';
import { PaymentInformationProps } from 'reservations/payments/types';

export const StripePaymentInformation = ({
  children
}: React.PropsWithChildren<PaymentInformationProps>) => {
  const stripePublishableKey = useStripePayments();
  const stripe = useStripe(stripePublishableKey);

  return (
    <Elements stripe={stripe} options={STRIPE_CIRCULAR_FONT}>
      <StripePaymentFormProvider>
        <CardFieldsContainer />
        {children}
      </StripePaymentFormProvider>
    </Elements>
  );
};
